<template>
  <div class="page page-Request" :class="{ loaded: isLoaded }">

    <div class="pictures m25" v-if="!isMobile">
        <div class="picture" :style="bgImgStyle(backgroundImages)"></div>
    </div>

    <div class="content m50">

      <router-link :to="{ name: 'Vacancy' }" class="close"></router-link>

      <transition enter-active-class="animated" leave-active-class="animated fadeOutUp">
        <div v-if="!requestSent" class="block-slideUp">

          <div class="form m50" v-if="!isMobile">
            <div class="title">{{ _('title') }}</div>

            <div class="form__row">
              <div class="form__row__title">{{ _('formFIO') }}</div>
              <input class="link" type="text" v-model="form.fio" :class="{error: formRequired.fio}" @focus="formRequired.fio = false">
            </div>

            <div class="form__row form__row-with-cols">
              <div class="form__col">
                <div class="form__row__title">{{ _('formEmail') }}</div>
                <input class="link" type="text" v-model="form.email" :class="{error: formRequired.email}" @focus="formRequired.email = false">
              </div>

              <div class="form__col form__col-phone">
                <div class="form__row__title">{{ _('formPhone') }}</div>
                <the-mask class="link" :mask="['+7(###) ###-##-##']" v-model="form.phone" :class="{error: formRequired.phone}" @focus="formRequired.phone = false" />
              </div>
            </div>

            <div class="form__row">
              <div class="form__row__title">{{ _('formAbout') }}</div>
              <textarea class="link" v-model="form.text" :class="{error: formRequired.text}" @focus="formRequired.text = false"></textarea>
            </div>

            <div class="form__row">
              <div class="form__row__title">{{ _('formResume') }}</div>
              <input class="link" type="text" v-model="form.summary" :class="{error: formRequired.summary}" @focus="formRequired.summary = false">
            </div>

            <div class="form__row form__row-agreement">
              <a :href="_('linkConfirm')" target="_blank">{{ _('confirm') }}</a>
            </div>
          </div>

          <div class="form m50" v-if="isMobile">
            <div class="title">{{ _('title') }}</div>

            <div class="form__row">
              <input class="link" type="text" v-model="form.fio" :class="{error: formRequired.fio}" @focus="formRequired.fio = false" :placeholder="_('formFIO')">
            </div>

            <div class="form__row">
                <input class="link" type="text" v-model="form.email" :class="{error: formRequired.email}" @focus="formRequired.email = false" :placeholder="_('formEmail')">
            </div>

            <div class="form__row">
                <the-mask class="link" :mask="['+7(###) ###-##-##']" v-model="form.phone" :class="{error: formRequired.phone}" @focus="formRequired.phone = false" :placeholder="_('formPhone')" />
            </div>

            <div class="form__row">
              <textarea class="link" v-model="form.text" :class="{error: formRequired.text}" @focus="formRequired.text = false" :placeholder="_('formAbout')"></textarea>
            </div>

            <div class="form__row">
              <input class="link" type="text" v-model="form.summary" :class="{error: formRequired.summary}" @focus="formRequired.summary = false" :placeholder="_('formResume')">
            </div>

            <div class="form__row form__row-agreement">
              <a :href="_('linkConfirm')" target="_blank">{{ _('confirm') }}</a>
            </div>
          </div>

          <div class="request-btn-block" v-if="!isMobile">
            <span class="link btn btn-square" @click="checkRecaptcha()">
              <span v-if="!requestSent && !requestError">{{ _('send') }}</span>
              <span v-if="requestError">{{ _('error') }}</span>
            </span>
          </div>

        </div>
      </transition>

      <transition enter-active-class="animated fadeInUp" leave-active-class="animated">
        <div v-if="requestSent" class="block-slideUp">
          <div class="title">{{ _('thanksTitle') }}</div>

          <div v-html="_('thanks')"></div>
        </div>
      </transition>

    </div>

    <div class="request-btn-block" v-if="isMobile">
            <span class="link btn btn-square" @click="checkRecaptcha()">
              <span v-if="!requestSent && !requestError">{{ _('send') }}</span>
              <span v-if="requestError">{{ _('error') }}</span>
            </span>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import { TheMask } from 'vue-the-mask';
import { loader } from '../mixins/loader';
import { isMobile } from '../mixins/isMobile';
import { functions } from '../mixins/functions';

export default {
  name: 'Request',
  mixins: [loader, isMobile, functions],
  components: { TheMask },

  props: ['vacancyId'],

  data() {
    return {
      pageData: { page: 'Request', isRequestBtnHidden: true },
      recaptcha: {},
      vacancy: {
        id: 1,
        label: ''
      },
      backgroundImages: {},
      requestSent: false,
      requestError: false,
      form: {
        fio: '',
        email: '',
        phone: '',
        text: '',
        summary: ''
      },
      formRequired: {
        fio: false,
        email: false,
        phone: false,
        text: false,
        summary: false
      }
    };
  },

  deactivated() {
    var _t = this;
    _t.isLoaded = false;
  },

  activated() {
    var _t = this;

    if (_t.$store.state.pagesLoaded.App && _t.$store.state.pagesLoaded.Request) {
      _t.onActivated();
    } else {
      _t.$store.commit('loaderON');

      _t.$store.subscribe((mutation, state) => {
        if (mutation.type === 'pageLoaded' && mutation.payload.page === 'Request') {
          _t.onActivated();
        }
      });

      if (_t.$store.state.vacanciesLoaded) {
        _t.onVacanciesLoaded();
      } else {
        _t.$store.subscribe((mutation, state) => {
          if (mutation.type === 'vacanciesLoaded') {
            _t.onVacanciesLoaded();
          }
        });
      }
    }
  },

  created() {
    let _t = this;

    _t.$store.dispatch('loadData', {
      page: 'Request'
    });
  },

  methods: {
    onActivated() {
      var _t = this;
      _t.backgroundImages = _t._('backgroundImages');
      _t.recaptcha = _t._('recaptcha');

      if (_t.imagesLoaded) {
        _t.pageLoaded();
      } else {
        _t.loadImages(_t.backgroundImages);
      }
    },
    onVacanciesLoaded() {
      var _t = this;

      if (_t.vacancyId !== 'vacancy') {
        for (let i in _t.$store.state.filterCities) {
          for (let j in _t.$store.state.filterCities[i].filterDepartments) {
            for (let ii in _t.$store.state.filterCities[i].filterDepartments[j].vacancies) {
              if (_t.vacancyId === _t.$store.state.filterCities[i].filterDepartments[j].vacancies[ii].id) {
                _t.$store.commit('changeDepartment', { val: { id: _t.$store.state.filterCities[i].filterDepartments[j].id } });

                _t.vacancy = _t.$store.state.filterCities[i].filterDepartments[j].vacancies[ii];
                break;
              }
            }
          }
        }
      }
    },
    sendRequest(recaptchaToken) {
      var _t = this;

      _t.form.vacancy = _t.vacancy;

      axios.post(_t.$store.state.apiUrl, {
        action: 'request',
        params: _t.form,
        recaptchaToken: recaptchaToken
      })
        .then(function(response) {
          if (response.data.success) {
            _t.requestSent = true;
          } else {
            _t.requestError = true;
          }
        })
        .catch(function(error) {
          /* eslint-disable no-console */
          console.log(error);
        });
    },
    checkRecaptcha() {
      var _t = this;

      _t.formRequired.fio = !_t.form.fio;
      _t.formRequired.email = !_t.form.email;
      _t.formRequired.phone = !_t.form.phone;
      _t.formRequired.text = !_t.form.text;
      _t.formRequired.summary = !_t.form.summary;

      if (
        _t.formRequired.fio ||
                _t.formRequired.email ||
                _t.formRequired.phone ||
                _t.formRequired.summary ||
                _t.formRequired.text
      ) {
        return false;
      }

      this.$recaptcha('login').then((token) => {
        _t.sendRequest(token); // Will print the token
      });
    }
  }
};
</script>
